const SearchCore = require('core/search/search');

SearchCore.initRefinements = function () {
    $('.container').on('click', 'button.filter-results', function () {
        $('.refinement-bar').addClass('show');
    });

    $('.container').on('click', '.refinement-bar button.close, .modal-background', function () {
        $('.refinement-bar').removeClass('show');
    });

    $('.save-vehicle-btn').on('click', (e) => {
        var $this = $(e.currentTarget);

        $('.installation-guide-btn').removeClass('active');
        $('.guide-button-container').removeClass('active');
        $('.how-to-btn').removeClass('active');
        $('.toggle-guide-btn').removeClass('active-icon');
        $('.bulb-finder-mainheader').removeClass('active');
        $('.installation-guide-main-container').removeClass('active');
        $('.save-vehicle-main-container').toggleClass('active');
        $this.toggleClass('active');

        if ($this.hasClass('active')) {
            $('.guide-button-container .car-icon').attr('src' , 'https://i.ibb.co/GJF1NK2/car-active.png');
            $('.guide-button-container .bulb-icon').attr('src' , 'https://i.ibb.co/PwF0hLC/bulb.png');
            $('.guide-button-container .tools-icon').attr('src' , 'https://i.ibb.co/PFSHK5X/tools.png');
            $('.installation-guide-btn .option-icon').removeClass('fa-minus').addClass('fa-plus');
            $this.addClass('active-icon');
        } else {
            $('.guide-button-container .car-icon').attr('src' , 'https://i.ibb.co/jDWNRyf/car.png');
            $this.removeClass('active-icon');
        }
    });
    
    $('.installation-guide-btn').on('click', (e) => {
        var $this = $(e.currentTarget);
       
        $('.save-vehicle-btn').removeClass('active');
        $('.save-vehicle-btn').removeClass('active-icon');
        $('.how-to-btn').removeClass('active');
        $('.how-to-btn').removeClass('active-icon');
        $('.bulb-finder-mainheader').removeClass('active');
        $('.save-vehicle-main-container').removeClass('active');
        $this.toggleClass('active');
        $('.installation-guide-main-container').toggleClass('active');

        if ($this.hasClass('active')) {
            $('.guide-button-container .bulb-icon').attr('src' , 'https://i.ibb.co/h1jDypW/Bulb-active.png');
            $('.guide-button-container .car-icon').attr('src' , 'https://i.ibb.co/jDWNRyf/car.png');
            $('.guide-button-container .tools-icon').attr('src' , 'https://i.ibb.co/PFSHK5X/tools.png');
            $('.installation-guide-btn .option-icon').removeClass('fa-plus').addClass('fa-minus');
            $this.addClass('active-icon');
            $this.parent().addClass('active');
        } else {
            $('.guide-button-container .bulb-icon').attr('src' , 'https://i.ibb.co/PwF0hLC/bulb.png');
            $('.installation-guide-btn .option-icon').removeClass('fa-minus').addClass('fa-plus');
            $this.removeClass('active-icon');
            $this.parent().removeClass('active');
        }
    });

    $('.bulb-finder-mainheader .how-to-btn').on('click', (e) => {
        var $this = $(e.currentTarget);

        $('.save-vehicle-btn').removeClass('active');
        $('.save-vehicle-btn').removeClass('active-icon');
        $('.installation-guide-btn').removeClass('active');
        $('.installation-guide-btn').removeClass('active-icon');
        $('.guide-button-container').removeClass('active');
        $('.installation-guide-main-container').removeClass('active');
        $('.save-vehicle-main-container').removeClass('active');
        $this.toggleClass('active-icon');
        $this.toggleClass('active');
        $('.bulb-finder-mainheader').toggleClass('active');

        if ($this.hasClass('active-icon')) {
            $('.guide-button-container .tools-icon').attr('src' , 'https://i.ibb.co/bgFRk5D/tools-active.png');
            $('.guide-button-container .car-icon').attr('src' , 'https://i.ibb.co/jDWNRyf/car.png');
            $('.guide-button-container .bulb-icon').attr('src' , 'https://i.ibb.co/PwF0hLC/bulb.png');
            $('.installation-guide-btn .option-icon').removeClass('fa-minus').addClass('fa-plus');
        } else {
            $('.guide-button-container .tools-icon').attr('src' , 'https://i.ibb.co/PFSHK5X/tools.png');
        }

        setTimeout(() => { 
            if($this.hasClass('slick-active')) {
                $this.removeClass('slick-active');
        
                $('.how-to-carousel-slider').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    fade: true,
                    infinite: false,
                    asNavFor: '.carousel-nav-for-how-to'
                });
        
                $('.carousel-nav-for-how-to').slick({
                    slidesToShow: 7,
                    arrows: false,
                    slidesToScroll: 7,
                    asNavFor: '.how-to-carousel-slider',
                    dots: false,
                    centerMode: true,
                    infinite: false,
                    focusOnSelect: true,
                    responsive: [
                    {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 6,
                        centerMode: false,
                        slidesToScroll: 1,
                        infinite: false
                    }
                    },
                        {
                        breakpoint: 768,
                        settings: {
                            arrows: false,
                            slidesToScroll: 1,
                            slidesToShow: 5,
                            centerMode: false
                        }
                    },
                        {
                        breakpoint: 480,
                        settings: {
                            slidesToScroll: 1,
                            slidesToShow: 5,
                            centerMode: false
                        }
                        }
                    ]
                });
            }
        }, 100);
    });

    $('body').on('click','.nav-link-BulbFinder',function() {
        var currID = $(this).data('id');
        $('.bulb-finder-row-main .tab-pane.container').removeClass('active');
        $('.' + currID).addClass('active');
    });

    $('body').on('click','.bulb-btn-container',function() {
        $('.which-bulb-content').toggleClass('active');
        $('.which-bulb-footer').toggleClass('active');
        $('.consult-footer').toggleClass('active');
        $(this).toggleClass('active');
        $('.bulb-finder-row-main').toggleClass('none');

        if ($(this).hasClass('active')) {
            $('.bulb-btn-container .fas').removeClass('fa-plus');
            $('.bulb-btn-container .fas').addClass('fa-minus');
        } else {
            $('.bulb-btn-container .fas').addClass('fa-plus');
            $('.bulb-btn-container .fas').removeClass('fa-minus');
        }
    });

    $('body').on('click','.btn-position',function() {
        $('.btn-position').removeClass('active');
        $(this).addClass('active');
        var pos = $(this).data('type');
        $('.content-position').removeClass('active');
        $('.' + pos + '-bulb').addClass('active');
    });

    $('body').on('click','#isBulbFinder .edit-bulb-search',function() {
        $(this).toggleClass('active');
        $('.refinement-bar').toggleClass('active');
        $('.edit-background').toggleClass('active');
        $('#isBulbFinder .search-results .grid-wrapper').toggleClass('edit-active');
        $('.installation-guide-main-container').removeClass('active');
        $('.save-vehicle-main-container').removeClass('active');
        $('.save-vehicle-btn').removeClass('active');
        $('.save-vehicle-btn').removeClass('active-icon');
        $('.how-to-btn').removeClass('active');
        $('.how-to-btn').removeClass('active-icon');
        $('.bulb-finder-mainheader').removeClass('active');
        $('.installation-guide-btn').removeClass('active');
        $('.installation-guide-btn').removeClass('active-icon');
        $('.guide-button-container .car-icon').attr('src' , 'https://i.ibb.co/jDWNRyf/car.png');
        $('.guide-button-container .bulb-icon').attr('src' , 'https://i.ibb.co/PwF0hLC/bulb.png');
        $('.guide-button-container .tools-icon').attr('src' , 'https://i.ibb.co/PFSHK5X/tools.png');
    });
};

SearchCore.resetRefinementsBtn = function () {
    return;
}



module.exports = SearchCore;